import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { KENDO_CHARTS } from '@progress/kendo-angular-charts';
import { FiltreAccueilPeriode } from '../../../FiltreAccueilPeriode';
import { RetournerStatistiquesRepartitionParStatutResultat } from '../../../RetournerStatistiquesRepartitionParStatutResultat';
import { EFactVenteService } from '../../../val-efact-vente.service';
import { CarteDashboardComponent } from '../../carte-dashboard/carte-dashboard.component';

// Carte de répartition des factures de vente par statut
@Component({
	selector: 'val-carte-repartition-statuts-vente',
	imports: [
		TranslocoModule,
		KENDO_CHARTS,
		CarteDashboardComponent
	],
	templateUrl: './carte-repartition-statuts.component.html',
	styleUrl: './carte-repartition-statuts.component.scss'
})
export class CarteRepartitionStatutsVenteComponent implements OnInit, OnChanges {

	constructor(private eFactVenteService: EFactVenteService) {
		this.filtrePeriode = FiltreAccueilPeriode.TrenteJours;
		this.chargementEnCours = false;
		this.estEnErreur = false;
		this.estVide = false;
		this.donnees = null;
	}

	// Période sélectionnée dans le filtre temporel
	@Input()
	public filtrePeriode: FiltreAccueilPeriode;

	// Indique si le chargement des données est en cours
	public chargementEnCours: boolean;

	// Indique si le dernier chargement s'est soldé par une erreur
	public estEnErreur: boolean;

	// Indique si le chargement a réussi mais qu'aucune thématique n'est à afficher
	public estVide: boolean;

	// Données de la carte
	public donnees: RetournerStatistiquesRepartitionParStatutResultat | null;

	public async ngOnInit(): Promise<void> {
		await this.chargerDonnees();
	}

	public async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes['filtrePeriode'] && !changes['filtrePeriode'].firstChange)
			await this.chargerDonnees();
	}

	private async chargerDonnees(): Promise<void> {
		this.chargementEnCours = true;
		this.estEnErreur = false;
		this.estVide = false;
		this.donnees = null;

		try {
			const resultat = await this.eFactVenteService.RetournerStatistiquesRepartitionParStatut(this.filtrePeriode);
			if (resultat.status === 'success' && resultat.resultat) {
				this.donnees = resultat.resultat;
				this.estVide = this.donnees.thematiques.length === 0;
			} else {
				this.estEnErreur = true;
			}
		} catch {
			this.estEnErreur = true;
		} finally {
			this.chargementEnCours = false;
		}
	}
}